import React, {useContext, useEffect, useState} from "react";
import { Grid, Row, Col } from "react-flexbox-grid";
import {Avatar} from "antd";
import AEPNavbarBrand from "./aep-navbar-brand";
import NotificationDropdown from "./notification-dropdown";
import "bootstrap/dist/css/bootstrap.css";
import {Dropdown, DropdownMenu, DropdownToggle, DropdownItem} from "reactstrap";
import {Link, withRouter} from "react-router-dom";
import { UserOutlined } from '@ant-design/icons';
import {getOriginIfLocal} from "../../utils/util";
import {getStationRegions, getTFSPCAreas, getTfStationAreas, getUserProfile} from "../../api";
import UserPreferenceDialog from "../../components/UserPreferenceDialog";
import {confirmAlert} from "react-confirm-alert";
import Cookies from 'js-cookie';
import comm_tool_context from "containers/common/comm_tool_context";
import { useOktaAuth } from "@okta/okta-react";
import { setGlobalAuth } from "utils/UserInfo";

function DesktopNavigation(props)
{
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [userProfile, setUserProfile] = useState(null);
    const context = useContext(comm_tool_context);
    const { oktaAuth, authState } = useOktaAuth();

   const handleLogout = async (e) => {
  if (e) e.preventDefault();
  try {
    console.log(">>>>>>> Logout process started");

    document.cookie = "aep=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    await oktaAuth.signOut({
      postLogoutRedirectUri: window.location.origin
    });
  } catch (err) {
    console.error("Logout Failed, ", err);
    document.cookie = "aep=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    window.location.href = '/';
  }
};

    useEffect(() => {
        if (authState) {
            setGlobalAuth(authState);
        }
    }, [authState]);


  useEffect(() => {
    const fetchData = async() => {
      try{
      const user = await getUserProfile();
      const defaultPreferencesArray = {
        selectedStatRegs: user && user.myStationRegions ? user.myStationRegions.split(',') : [],
        selectedStatAreas: user && user.myTFSStationAreas ? user.myTFSStationAreas.split(',') : [],
        selectedPCAreas: user && user.myTFSPCAreas ? user.myTFSPCAreas.split(',') : [],
        selectedProjFlag: (user && user.myProjectsFlag) || '',
        selectedDefaultDashView: (user && user.myProjectStatus) || ''
      };
      const getFilterSelectionCookieJson = Cookies.get('filters');
      const parsedFilterSelectionsJson = getFilterSelectionCookieJson ? JSON.parse(getFilterSelectionCookieJson) : {};
      defaultPreferencesArray.stationName = parsedFilterSelectionsJson.stationName ? parsedFilterSelectionsJson.stationName : '';
      defaultPreferencesArray.bpid = parsedFilterSelectionsJson.bpid ? parsedFilterSelectionsJson.bpid : '';
      defaultPreferencesArray.mpid = parsedFilterSelectionsJson.mpid ? parsedFilterSelectionsJson.mpid : '';
      defaultPreferencesArray.workOrder = parsedFilterSelectionsJson.workOrder ? parsedFilterSelectionsJson.workOrder : '';
      defaultPreferencesArray.constructionEndDate = parsedFilterSelectionsJson.constructionEndDate ? parsedFilterSelectionsJson.constructionEndDate : '';
      defaultPreferencesArray.constructionStartDate = parsedFilterSelectionsJson.constructionStartDate ? parsedFilterSelectionsJson.constructionStartDate : '';
      defaultPreferencesArray.inServiceStartDate = parsedFilterSelectionsJson.inServiceStartDate? parsedFilterSelectionsJson.inServiceStartDate: '';
      defaultPreferencesArray.inServiceEndDate = parsedFilterSelectionsJson.inServiceEndDate? parsedFilterSelectionsJson.inServiceEndDate: '';
      defaultPreferencesArray.commisioningStartDate = parsedFilterSelectionsJson.commisioningStartDate ? parsedFilterSelectionsJson.commisioningStartDate : '';
      defaultPreferencesArray.commisioningEndDate = parsedFilterSelectionsJson.commisioningEndDate ? parsedFilterSelectionsJson.commisioningEndDate : '';
      defaultPreferencesArray.expectedCloseStartDate = parsedFilterSelectionsJson.expectedCloseStartDate ? parsedFilterSelectionsJson.expectedCloseStartDate: '';
      defaultPreferencesArray.expectedCloseEndDate = parsedFilterSelectionsJson.expectedCloseEndDate? parsedFilterSelectionsJson.expectedCloseEndDate: '';
      defaultPreferencesArray.constructionDateNull = parsedFilterSelectionsJson.constructionDateNull;
      defaultPreferencesArray.inServiceDateNull = parsedFilterSelectionsJson.inServiceDateNull;
      defaultPreferencesArray.commisioningDateNull = parsedFilterSelectionsJson.commisioningDateNull;
      defaultPreferencesArray.expectedDateNull = parsedFilterSelectionsJson.expectedDateNull;
      Cookies.set('filters', defaultPreferencesArray);
      setUserProfile(user);
      if(context && context.setUserProfile){
          context.setUserProfile(user);
          context.setLaunchDashboard(true);
      }
    } catch(error){
      console.error(" Navigating Error ", error);
    }
  };
   fetchData();
  }, []);

  function toggleDropdown() {
    setDropdownOpen(!dropdownOpen);
  }

  return (
      <Grid fluid>
        <Row middle="xs" start="xs" between="xs" className="pt-1">
          <Col xs={3} className="pl-2">
            <AEPNavbarBrand />
          </Col>
          <Col xs={5}>

          </Col>
          <Col xs={1} style={{textAlign: "right"}}>
            <a className="text-dark font-weight-bold" href="/"/>
          </Col>
          <Col xs={1} style={{textAlign: "right"}}>
            <a className="text-muted" href="/"/>
          </Col>
          <Col xs={1} style={{textAlign: "right"}}>
            <NotificationDropdown {...props} />
          </Col>
          <Col xs={0} sm={1} style={{textAlign: "left"}}>
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} style={{ boxShadow: "none" }}>
              <DropdownToggle color="white">
                <Avatar size="large" icon={<UserOutlined />}/>
              </DropdownToggle>
              <DropdownMenu right style={{ width: "400", height: "400", overflow: "none", borderColor: "#0ca0da"}}>
                <DropdownItem>
                  <Grid fluid>
                    <Row><b>{userProfile !== null ? (userProfile.firstName+' '+userProfile.lastName) : ' '}</b></Row>
                    <Row style={{ textAlign: 'left'}}>
                      <Col xs={2} md={2} lg={2}>
                        <i className='fa fa-solid fa-id-card fa-1x'/>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        {userProfile !== null ? userProfile.userId : ' '}
                      </Col>
                    </Row>
                    <Row style={{ textAlign: 'left'}}>
                      <Col xs={2} md={2} lg={2}>
                        <i className='fa fa-solid fa-key fa-1x'/>
                      </Col>
                      <Col xs={8} md={8} lg={8}>
                        {userProfile !== null && userProfile.userRole !== null ? userProfile.userRole : ' '}
                      </Col>
                    </Row>
                    <Row style={{ textAlign: 'left'}}>
                      <Col xs={2} md={2} lg={2}>
                        <i className='fa fa-solid fa-envelope fa-1x'/>
                      </Col>
                      <Col xs={8} md={8} lg={8}>
                        {userProfile !== null ? userProfile.email : ' '}
                      </Col>
                    </Row>
                    <Row style={{ textAlign: 'left'}}>
                      <Col xs={2} md={2} lg={2}>
                        <i className='fa fa-solid fa-phone fa-1x'/>
                      </Col>
                      <Col xs={8} md={8} lg={8}>
                        {userProfile !== null && userProfile.phoneNumber !== null ? userProfile.phoneNumber : ' '}
                      </Col>
                    </Row>
                    <Row style={{ textAlign: 'left'}}>
                      <Col xs={2} md={2} lg={2}>
                        <i className='fa fa-solid fa-mobile-phone fa-1x'/>
                      </Col>
                      <Col xs={8} md={8} lg={8}>
                        {userProfile !== null && userProfile.cellNumber !== null ? userProfile.cellNumber : ' '}
                      </Col>
                    </Row>
                    <Row style={{ textAlign: 'left'}}>
                      <Col xs={2} md={2} lg={2}>
                        <i className='fa fa-solid fa-briefcase fa-1x'/>
                      </Col>
                      <Col xs={8} md={8} lg={8}>
                        {userProfile !== null ? userProfile.company : ' '}
                      </Col>
                    </Row>
                  </Grid>
                </DropdownItem>
                <DropdownItem onClick={()=>onUserPreferenceClick()}>
                  <i className='fa fa-solid fa-gear fa-1x'/>{'   '}<u style={{color:'blue'}}>User Preferences</u></DropdownItem>
                <DropdownItem>
                  <i className='fa fa-solid fa-gear fa-1x'/>{'   '}
                  <Link to={`/dashboard/Admin`} target={'_blank'}><u style={{color:'blue'}}>{'Admin'}</u></Link>
                </DropdownItem>
                {/* <DropdownItem href={`${getOriginIfLocal()}/logout`} style={{marginLeft:'5px'}}>
                  <i className='fa fa-solid fa-sign-out fa-1x'/>{'   '}<u style={{color:'blue'}}>{'Log out'}</u></DropdownItem>
              </DropdownMenu> */}
              <DropdownItem onClick={handleLogout} style={{cursor: 'pointer', marginLeft:'5px'}}>
    <i className='fa fa-solid fa-sign-out fa-1x'/>{'   '}
    <u style={{color:'blue'}}>{'Log out'}</u>
</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Col>
        </Row>
      </Grid>
  );

  async function onUserPreferenceClick()
  {
    //console.log('props..........from user pref', props);
    const StationRegionsResponse = await getStationRegions();
    const stationRegions = StationRegionsResponse.data.map((region,index) => {
      return {id: index, name: region}
    });
    const TFSStationAreasResponse = await getTfStationAreas();
    const stationAreas = TFSStationAreasResponse.data.map((area,index) => {
      return {id: index, name: area}
    });
    const TFSPCAreasResponse = await getTFSPCAreas();
    const pcAreas = TFSPCAreasResponse.data.map((area,index) => {
      return {id: index, name: area}
    });

    confirmAlert({
      closeOnClickOutside: false,
      closeOnEscape: true,

      customUI: ({ onClose }) => {
        return (
            <UserPreferenceDialog context={context} userProfile={userProfile} setUserProfile={setUserProfile}
                                  onClose={onClose} stationRegions={stationRegions} stationAreas={stationAreas} pcAreas={pcAreas}/>
        );
      }
    });
  }
}

export default withRouter(DesktopNavigation);
